import { MetamaskService } from '@/src/services/MetamaskService'
import { useCallback, useEffect } from 'react'
import { atom, useRecoilState } from 'recoil'

const walletAddressAtom = atom<string | undefined>({ key: 'MetamaskWalletChainId', default: undefined })

export const useMetamaskWalletChainId = () => {
  const [chainId, setWalletChainId] = useRecoilState(walletAddressAtom)
  const updateChainId = useCallback(() => {
    MetamaskService.getCurrentChainId().then((id) => {
      setWalletChainId(id ? `0x${id.toString(16)}` : undefined)
    })
  }, [setWalletChainId])

  useEffect(() => {
    updateChainId()
    window.ethereum.on('chainChanged', updateChainId)
    return () => {
      window.ethereum.removeListener('chainChanged', updateChainId)
    }
  }, [updateChainId])

  return { chainId }
}
